module.exports = __webpack_public_path__ + "static/media/046-security.69137397.svg";